import '../scss/index.scss';

import './modules/ua';
import "./modules/links";
